import { render, staticRenderFns } from "./systemsettings.vue?vue&type=template&id=10644431&scoped=true&"
import script from "./systemsettings.vue?vue&type=script&lang=js&"
export * from "./systemsettings.vue?vue&type=script&lang=js&"
import style0 from "./systemsettings.vue?vue&type=style&index=0&id=10644431&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10644431",
  null
  
)

export default component.exports